module.exports = __webpack_public_path__ + "img/icon-txt.62dcb143.png";